/**
 * Referral tracking — frontend allowlist + localStorage helpers.
 *
 * To add another referral partner later:
 *   1. Add a new entry to VALID_REFERRALS below
 *   2. Add the SAME code (lowercase) to /app/backend/referrals.py -> REFERRALS
 *   3. Redeploy — that's it. No other files need touching.
 */

// code -> display label
export const VALID_REFERRALS = {
    cuzzin: "Cuzzin",
};

const STORAGE_KEY = "qgl_ref_v1";
const TTL_DAYS = 30;
const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

/** Validate + normalize a raw ?ref= value against the allowlist. */
export const normalizeRef = (raw) => {
    if (!raw || typeof raw !== "string") return null;
    const cleaned = raw.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(VALID_REFERRALS, cleaned) ? cleaned : null;
};

/** Human-readable label for a code, or null. */
export const labelForRef = (code) => VALID_REFERRALS[normalizeRef(code)] || null;

/** Persist a validated referral code to localStorage with a 30-day TTL. */
export const persistRef = (code) => {
    const key = normalizeRef(code);
    if (!key) return null;
    try {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ code: key, ts: Date.now() }),
        );
    } catch (e) {
        // localStorage unavailable (Safari private mode, etc.) — silently ignore.
    }
    return key;
};

/** Return the currently-attributed referral code, or null if expired/missing. */
export const readRef = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.code || !parsed.ts) return null;
        if (Date.now() - parsed.ts > TTL_MS) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return normalizeRef(parsed.code);
    } catch (e) {
        return null;
    }
};

export const clearRef = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
};
